import { Box, Tooltip } from '@mui/material';
import ConfirmationNumberOutlinedIcon from '@mui/icons-material/ConfirmationNumberOutlined';
import Iconify from 'src/components/iconify';
import Label from 'src/components/label';

export function BenefitImageCell({ value, name }: { value: unknown; name?: string }) {
  const image = String(value || '');
  const alt = name || 'Benefício';

  if (!image) return <>-</>;

  return (
    <Tooltip
      arrow
      placement="left"
      title={
        <Box
          component="img"
          src={image}
          alt={alt}
          sx={{
            display: 'block',
            width: 240,
            maxHeight: 240,
            objectFit: 'contain',
            borderRadius: 0.75,
          }}
        />
      }
      slotProps={{
        tooltip: {
          sx: {
            p: 0.5,
            borderRadius: 1,
            bgcolor: 'common.white',
            boxShadow: 8,
          },
        },
      }}
    >
      <Box
        component="img"
        src={image}
        alt={alt}
        sx={{
          display: 'block',
          width: 72,
          height: 40,
          borderRadius: 0.75,
          objectFit: 'cover',
          border: '1px solid',
          borderColor: 'grey.300',
        }}
      />
    </Tooltip>
  );
}

export function BenefitTypeCell({ value }: { value: unknown }) {
  const isCoupon = String(value || '').toLowerCase() === 'cupom';

  return (
    <Box
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 1,
        px: 1.6,
        py: 0.6,
        borderRadius: 999,
        border: '1px solid',
        borderColor: 'grey.300',
        backgroundColor: 'grey.100',
        color: 'text.primary',
        fontWeight: 600,
        minWidth: 110,
      }}
    >
      {isCoupon ? (
        <ConfirmationNumberOutlinedIcon sx={{ fontSize: 18 }} />
      ) : (
        <Iconify icon="mdi:cube-outline" sx={{ width: 18, height: 18 }} />
      )}
      <Box component="span">{isCoupon ? 'Cupom' : 'Produto'}</Box>
    </Box>
  );
}

export function BenefitDateCell({
  value,
  formatDate,
}: {
  value: unknown;
  formatDate: (isoDate: string) => string;
}) {
  const normalizedValue = String(value ?? '')
    .trim()
    .toLowerCase();
  if (
    ['', 'null', 'undefined'].includes(normalizedValue) ||
    Number.isNaN(new Date(String(value)).getTime())
  ) {
    return (
      <Label
        variant="soft"
        color="default"
        sx={{
          border: '1px solid',
          borderColor: 'grey.300',
          color: 'text.secondary',
          fontWeight: 700,
        }}
      >
        Sem data
      </Label>
    );
  }

  return (
    <Box sx={{ width: 1, display: 'flex', justifyContent: 'flex-start' }}>
      <Label
        variant="outlined"
        sx={{
          gap: 0.75,
          px: 1.4,
          py: 0.45,
          display: 'inline-flex',
          alignItems: 'center',
          fontWeight: 700,
        }}
      >
        <Iconify icon="mdi:calendar-month-outline" sx={{ width: 16, height: 16 }} />
        {formatDate(String(value))}
      </Label>
    </Box>
  );
}
